import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// Twin > Ask me: drag a question by its handle to put it where you want it on
// your page (ProfilePageAnswersController#reorder). Pointer events, so a
// mouse and a finger both work; arrow keys move a focused handle up or down.
// The order saves when you let go.
export default class extends Controller {
  static values = { url: String, kind: { type: String, default: "answer" } }

  start(event) {
    if (event.button !== undefined && event.button !== 0) return
    const item = event.currentTarget.closest(`[data-${this.kindValue}-id]`)
    if (!item) return
    event.preventDefault()
    this._item = item
    this._pointer = event.pointerId
    try { event.currentTarget.setPointerCapture(event.pointerId) } catch (_error) { /* synthetic */ }
    item.classList.add("is-dragging")
    this._before = this._ids().join(",")
    this._move = (moved) => this._drag(moved)
    this._up = () => this._end()
    window.addEventListener("pointermove", this._move)
    window.addEventListener("pointerup", this._up)
    window.addEventListener("pointercancel", this._up)
  }

  key(event) {
    if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return
    event.preventDefault()
    const item = event.currentTarget.closest(`[data-${this.kindValue}-id]`)
    const sibling = event.key === "ArrowUp" ? item.previousElementSibling : item.nextElementSibling
    if (!sibling) return
    event.key === "ArrowUp" ? sibling.before(item) : sibling.after(item)
    event.currentTarget.focus()
    this._save()
  }

  _drag(event) {
    if (!this._item || event.pointerId !== this._pointer) return
    const items = this._items().filter((item) => item !== this._item)
    const after = items.find((item) => {
      const box = item.getBoundingClientRect()
      return event.clientY < box.top + box.height / 2
    })
    after ? after.before(this._item) : this.element.append(this._item)
  }

  _end() {
    window.removeEventListener("pointermove", this._move)
    window.removeEventListener("pointerup", this._up)
    window.removeEventListener("pointercancel", this._up)
    if (!this._item) return
    this._item.classList.remove("is-dragging")
    this._item = null
    if (this._ids().join(",") !== this._before) this._save()
  }

  async _save() {
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrfToken() },
        body: JSON.stringify({ ids: this._ids() })
      })
      if (!response.ok) throw new Error()
    } catch (_error) {
      this.element.classList.add("is-unsaved")
    }
  }

  _items() {
    return Array.from(this.element.querySelectorAll(`:scope > [data-${this.kindValue}-id]`))
  }

  _ids() {
    return this._items().map((item) => item.dataset[`${this.kindValue}Id`])
  }
}
